export default {
  listItemSubtextColor: Styles.color.grey.one,
  listItemTitleColor: Styles.color.grey.one,
};
